import * as LucideIcons from 'lucide-react';
import type { Team } from '../types/employee';

interface TeamIconProps {
  team: Pick<Team, 'iconType' | 'iconValue'>;
  size?: number;
  className?: string;
}

const TeamIcon = ({ team, size = 14, className = '' }: TeamIconProps) => {
  if (team.iconType === 'image' && team.iconValue) {
    return (
      <img
        src={team.iconValue}
        alt=""
        className={className}
        style={{ width: size, height: size, objectFit: 'cover', borderRadius: 2, flexShrink: 0 }}
      />
    );
  }

  if (team.iconType === 'emoji' && team.iconValue) {
    return (
      <span style={{ fontSize: size, lineHeight: 1, flexShrink: 0 }} className={className}>
        {team.iconValue}
      </span>
    );
  }

  if (team.iconType === 'lucide' && team.iconValue) {
    const Icon = (LucideIcons as Record<string, React.ComponentType<{ size?: number; className?: string }>>)[team.iconValue];
    if (Icon) {
      return <Icon size={size} className={className} />;
    }
  }

  // Fallback
  const { Tag } = LucideIcons;
  return <Tag size={size} className={className} />;
};

export default TeamIcon;
